import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "../design-system";
import { colors } from "../design-system/colors";
import Divider from "../design-system/Divider";
import { SUBSCRIPTION_TAB } from "./constants/accountText";
import PlanBadge from "./PlanBadge";
import { useSubscriptionStatus } from "./hooks/useSubscriptionStatus";
import { ROUTES } from "../../constants/routes";

export interface SubscriptionTabProps {}

const SubscriptionTab = (_props: SubscriptionTabProps) => {
  const { plan, loadError } = useSubscriptionStatus();
  const navigate = useNavigate();
  const isPaid = !!plan && plan.trim().toLowerCase() !== "free";

  return (
    <Box
      sx={{
        backgroundColor: colors.card.profileBackground,
        borderRadius: "16px",
        padding: "32px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        width: "100%",
        minHeight: "400px",
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: "34px",
          color: colors.neutral.white,
        }}
      >
        {SUBSCRIPTION_TAB.SECTION_TITLE}
      </Box>

      <Divider />

      {loadError ? (
        <Box
          sx={{
            fontFamily: "Outfit, sans-serif",
            fontSize: "14px",
            color: colors.error[400],
          }}
        >
          {SUBSCRIPTION_TAB.LOADING_ERROR}
        </Box>
      ) : (
        <>
          <PlanBadge plan={plan} />
          {/* Paid: manage / cancel (the page's Cancel button stops it at the end of the paid
              month). Free: the plans. Before this the tab showed only the plan's name. */}
          <Box>
            <Button
              variant={isPaid ? "outlined" : "primary"}
              onClick={() => navigate(isPaid ? ROUTES.SUBSCRIPTION_MANAGE : ROUTES.SUBSCRIPTION)}
              sx={{ px: 3 }}
            >
              {isPaid ? SUBSCRIPTION_TAB.MANAGE_BUTTON : SUBSCRIPTION_TAB.PLANS_BUTTON}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default SubscriptionTab;
